import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { BlockingError } from '../lib/custom-errors'
import { useIntl } from '../localization/react'
import getPhoenixUrlParams from '../lib/get-phoenix-url-params'
import { useOrderAbortHandlerAbortOrderMutation } from '../graphql'
import sessionUtils from './session-utils'

// This component is basically used for the case where somehow the unload event
// that is currently being used by the payment timer, is not able to be executed
// and the order is not aborted, so when the application is reloaded, we check
// the session storage and abort the order stored, or else we just resume
// the normal behavior of the application
const OrderAbortHandler: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const intl = useIntl()
  const location = useLocation()

  const { cartId } = getPhoenixUrlParams(location.search)
  const [abortOrder] = useOrderAbortHandlerAbortOrderMutation()

  useEffect(() => {
    const orderId = sessionUtils.getAbortedOrderId()

    if (!orderId || cartId) {
      sessionUtils.removeAbortedOrderId()
    } else {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      abortOrder({ variables: { orderId } })
      sessionUtils.removeAbortedOrderId()

      throw new BlockingError('The order was aborted', intl.orderAbortedError())
    }
  }, [])

  return <>{children}</>
}

export default OrderAbortHandler
